import {Component, OnInit} from '@angular/core';
import { from, Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {CalculationComponent} from 'src/app/popup/configurations/calculation/calculation.component';
import {
  ConfigurationManagerComponent
} from 'src/app/popup/configurations/configuration-manager/configuration-manager.component';
import {DefaultAltitudesComponent} from 'src/app/popup/configurations/default-altitudes/default-altitudes.component';
import {DisplayComponent} from 'src/app/popup/configurations/display/display.component';
import {LayersComponent} from 'src/app/popup/configurations/layers/layers.component';
import {ProcedureComponent} from 'src/app/popup/configurations/procedure/procedure.component';
import {
  ProjectManagementControlComponent
} from 'src/app/popup/configurations/project-management-control/project-management-control.component';
import {RcsComponent} from 'src/app/popup/configurations/rcs/rcs.component';
import {RnavComponent} from 'src/app/popup/configurations/rnav/rnav.component';
import {TerrainsComponent} from 'src/app/popup/configurations/terrains/terrains.component';
import {GenericControlService} from 'src/app/popup/services/generic-control.service';
import {SearchService} from 'src/app/services/search.service';
import {MenuManagementService} from '../services/menu-management.service';
import {NetworkComponent} from 'src/app/popup/configurations/network/network.component';
import {FacilityComponent} from 'src/app/popup/configurations/facility/facility.component';
import {DirectoriesComponent} from 'src/app/popup/configurations/directories/directories.component';
import {
  ConfigurationColorSettingsComponent
} from 'src/app/popup/configuration-color-settings/configuration-color-settings.component';
import {
  ColorGradientCumulativeCoverageComponent
} from 'src/app/popup/color-gradient-cumulative-coverage/color-gradient-cumulative-coverage.component';
import {ConfigurationService} from 'src/app/services/configuration.service';
import {UserSpaceComponent} from 'src/app/popup/configurations/user-space/user-space.component';
import {ContextualHelpComponent} from 'src/app/popup/contextual-help/contextual-help.component';
import { TabsService } from 'src/app/services/tabsService';
import { ProjectService } from 'src/app/services/project.service';
import { GritUserService } from 'src/app/services/grit/grit.user.service';
import { SelectAntennaPatternComponent } from 'src/app/popup/select-antenna-pattern/select-antenna-pattern.component';
import { UtilsService } from 'src/app/services/utils.service';
import { UserManagementComponent } from 'src/app/popup/user-management/user-management.component';
import { UserProfileComponent } from 'src/app/popup/user-profile/user-profile.component';

@Component({
  selector: 'app-configuration-menu',
  templateUrl: './configuration-menu.component.html',
  styleUrls: ['./configuration-menu.component.scss'],
  standalone: false
})
export class ConfigurationMenuComponent implements OnInit {
  public isAdmin$: Observable<boolean>;

  constructor(public menuService: MenuManagementService,
    private popupService: BsModalService,
    private configurationService: ConfigurationService,
    public tabsService : TabsService,
    public projectController: ProjectService,
    public gritUserService: GritUserService,
    public readonly utilsService: UtilsService

    ) {}

  ngOnInit(): void {
    this.popupService.config.animated = false;
    // Resolve once and memoize admin status for template use
    this.isAdmin$ = from(this.utilsService.userIsAdmin()).pipe(shareReplay(1));
  }
  openProjectManager(){
    const bsModalRef : BsModalRef = this.popupService.show(ProjectManagementControlComponent);
  }

  openConfigurationManager(){
    const bsModalRef : BsModalRef = this.popupService.show(ConfigurationManagerComponent, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
  }

  openDirectories(){
    const bsModalRef : BsModalRef = this.popupService.show(DirectoriesComponent, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
  }

  openFacility(){
    const bsModalRef : BsModalRef = this.popupService.show(FacilityComponent, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
  }
  openNetwork(){
    const bsModalRef : BsModalRef = this.popupService.show(NetworkComponent, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
  }
  openTerrains(){
    const bsModalRef : BsModalRef = this.popupService.show(TerrainsComponent);
  }

  openCalculation(){
    const bsModalRef : BsModalRef = this.popupService.show(CalculationComponent, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
  }

  openRNAV(){
    const bsModalRef : BsModalRef = this.popupService.show(RnavComponent, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
  }

  openProcedure(){
    const bsModalRef : BsModalRef = this.popupService.show(ProcedureComponent, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
  }

  openDefaultAltitudes(){
    const bsModalRef : BsModalRef = this.popupService.show(DefaultAltitudesComponent, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
  }

  openRCS(){
    const bsModalRef : BsModalRef = this.popupService.show(RcsComponent, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
  }

  openLayers(){
    const bsModalRef : BsModalRef = this.popupService.show(LayersComponent, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
  }

  openDisplay(){
    const bsModalRef : BsModalRef = this.popupService.show(DisplayComponent, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
  }
  openConfigurationColorSettings(){
    this.popupService.show(ConfigurationColorSettingsComponent);
  }
  openChangeCumulativeCoverageColorGradient(){
    const bsModalRef : BsModalRef =  this.popupService.show(ColorGradientCumulativeCoverageComponent);
    bsModalRef.content.cumulativeCoverageColors = JSON.parse(this.configurationService.currentConfiguration.cumulativeColorSettingsJson);
  }

  openUserSpace(isAdminView: boolean = false){
    const bsModalRef: BsModalRef = this.popupService.show(UserSpaceComponent, {
      initialState: { isAdminView }
    });
  }

  openUserSpaceUser() {
    this.openUserSpace(false);
  }

  openUserSpaceAdmin() {
    this.openUserSpace(true);
  }
  openContextualHelp(){
    const bsModalRef : BsModalRef = this.popupService.show(ContextualHelpComponent);
  }
  editProjectDetailsTrigger(): void {
    if(this.projectController.projectEditable()){
      this.tabsService.openNewProjectDetailsTab();
    }
  }

  protected readonly TabsService = TabsService;

  openAntennaModels(){
    const bsModalRef : BsModalRef = this.popupService.show(SelectAntennaPatternComponent);
  }


  openUserManagement() {
    const bsModalRef: BsModalRef = this.popupService.show(UserManagementComponent);
  }

  openUserProfile() {
    const bsModalRef: BsModalRef = this.popupService.show(UserProfileComponent);
  }
}
